/**
 * Luxury Card Gallery — Fixed
 * Desktop: tracks mousemove delta, mouseup on document so release outside card still registers
 * Mobile: touchstart / touchend
 * Dot click + keyboard nav
 */
(function () {
  'use strict';

  function initGallery(galleryEl) {
    var slides = Array.prototype.slice.call(galleryEl.querySelectorAll('.lux-gallery__slide'));
    var dots   = Array.prototype.slice.call(galleryEl.querySelectorAll('.lux-gallery__dot'));
    if (slides.length < 2) return; // nothing to swipe with only 1 image

    var current    = 0;
    var startX     = 0;
    var dragging   = false;
    var moved      = false;   // did the pointer actually move?
    var THRESHOLD  = 35;      // px needed to trigger slide change

    /* ---- navigate to slide index ---- */
    function goTo(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;

      slides[current].classList.remove('is-active');
      var prevA = slides[current].querySelector('a');
      if (prevA) prevA.setAttribute('tabindex', '-1');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
        dots[current].setAttribute('tabindex', '-1');
      }

      current = idx;
      slides[current].classList.add('is-active');
      var nextA = slides[current].querySelector('a');
      if (nextA) nextA.setAttribute('tabindex', '0');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
        dots[current].setAttribute('tabindex', '0');
      }
    }

    /* ---- dot clicks ---- */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(i);
      });
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goTo(i); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      });
    });

    /* ---- TOUCH ---- */
    galleryEl.addEventListener('touchstart', function (e) {
      startX   = e.touches[0].clientX;
      dragging = true;
      moved    = false;
    }, { passive: true });

    galleryEl.addEventListener('touchmove', function () {
      moved = true;
    }, { passive: true });

    galleryEl.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) >= THRESHOLD) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });

    /* ---- MOUSE (desktop) ----
       mouseup is on document so releasing outside the card still fires */
    galleryEl.addEventListener('mousedown', function (e) {
      // Only main button
      if (e.button !== 0) return;
      startX   = e.clientX;
      dragging = true;
      moved    = false;
      e.preventDefault(); // prevent text selection during drag
    });

    galleryEl.addEventListener('mousemove', function () {
      if (dragging) moved = true;
    });

    // Listen on document so mouseup outside card is caught
    document.addEventListener('mouseup', function (e) {
      if (!dragging) return;
      dragging = false;
      if (!moved) return; // pure click — don't override link
      var diff = startX - e.clientX;
      if (Math.abs(diff) >= THRESHOLD) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    });

    // Prevent the img/link from starting a browser drag
    galleryEl.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // If user barely moved the mouse, let the click through to the <a> link
    galleryEl.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();  // swipe — don't navigate
        moved = false;
      }
    });
  }

  /* ---- init all galleries on page ---- */
  function initAll() {
    document.querySelectorAll('.lux-gallery').forEach(function (el) {
      if (!el.dataset.luxInited) {
        el.dataset.luxInited = '1';
        initGallery(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify section events and AJAX filter reloads
  document.addEventListener('shopify:section:load', function () {
    // Reset inited flags so galleries inside reloaded sections reinit
    document.querySelectorAll('.lux-gallery[data-lux-inited]').forEach(function (el) {
      delete el.dataset.luxInited;
    });
    initAll();
  });

  // MutationObserver for theme AJAX filter updates
  var mo = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1 && (n.classList.contains('lux-gallery') || (n.querySelector && n.querySelector('.lux-gallery')))) {
          found = true;
        }
      });
    });
    if (found) initAll();
  });

  function attachObserver() {
    var wrap = document.querySelector('.shop-product-wrap');
    if (wrap) mo.observe(wrap, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

}());
